export const id = {
  app: {
    name: "Aksaraku",
    tagline: "Belajar sambil bermain",
  },
  common: {
    on: "Nyala",
    off: "Mati",
    back: "Kembali",
    soon: "Segera hadir",
    loading: "Sebentar ya...",
  },
  nav: {
    parent: "Orang Tua",
    home: "Beranda",
    writing: "Menulis",
    games: "Permainan",
    collection: "Koleksi",
    avatar: "Karakter",
    groupLearn: "Belajar",
    groupParent: "Orang Tua",
    mainLabel: "Navigasi utama",
    offlineReady: "Offline siap",
    offlineActive: "Mode offline",
    mainProfile: "Profil utama",
  },
  profiles: {
    title: "Siapa yang mau main?",
    subtitle: "Pilih anak atau tambah profil baru",
    add: "Tambah Anak",
    namePlaceholder: "Nama anak",
    language: "Bahasa",
    start: "Mulai",
    empty: "Belum ada profil. Yuk tambah anak dulu.",
    errors: {
      emptyName: "Nama belum diisi",
      nameTooLong: "Nama terlalu panjang",
      invalidLocale: "Bahasa tidak dikenal",
    },
  },
  home: {
    greeting: "Halo, {{name}}!",
    tracing: "Menulis",
    games: "Permainan",
    rewards: "Koleksi",
    avatar: "Karakter",
    subtitle: "Mau belajar apa hari ini?",
    streak: "{{count}} hari",
    continue: {
      eyebrow: "Lanjutkan belajar",
      cta: "Lanjutkan",
      detail: "{{category}} · {{current}} dari {{total}} dikuasai",
    },
    stats: {
      stars: "{{count}} bintang",
      progress: "{{current}} dari {{total}} aksara dikuasai",
    },
    hint: {
      tracing: "Huruf, angka & bentuk",
      games: "3 mini-game seru",
      rewards: "Stiker, piala & karakter",
      avatar: "Kustomisasi temanmu",
    },
    progress: {
      title: "Progres aksara",
      sub: "{{current}} dari {{total}} aksara dikuasai",
      letters: "Huruf {{current}}/{{total}}",
      numbers: "Angka {{current}}/{{total}}",
      shapes: "Bentuk {{current}}/{{total}}",
    },
    reward: {
      title: "Hadiah berikutnya",
      count: "{{current}}/{{target}}",
    },
  },
  play: {
    title: "Ayo Menulis",
    pick: "Pilih huruf, angka, atau bentuk",
    retry: "Coba Lagi",
    next: "Lanjut",
    great: "Hebat!",
    strokeProgress: "Garis {{current}} dari {{total}}",
    offTrack: "Ikuti garisnya ya",
    listen: "Dengar",
    canvasLabel: "Area menulis {{glyph}}",
    objectHint: "{{glyph}} untuk {{object}}",
    color: "Warnai",
    letterTitle: "Huruf {{glyph}}",
    digitTitle: "Angka {{glyph}}",
    shapeTitle: "Bentuk",
    digitSub: "Menulis · 1 sampai 10",
    shapeSub: "Menulis · {{current}} dari {{total}}",
    ratio: "{{current}} / {{total}}",
    pickShape: "Pilih bentuk lain",
    tipLetter: "Mulai dari titik biru, ikuti titik oranye pelan-pelan ya.",
    tipDigit: "Ikuti arah panah dari titik awal. Pelan-pelan saja ya!",
    tipShape: "Ikuti garisnya pelan-pelan, jangan sampai keluar ya.",
    dragHint: "Tarik dari titik biru mengikuti titik oranye",
    progressTitle: "Progres",
    reset: "Ulangi",
    finish: "Selesai",
    nextDigit: "Lanjut ke angka {{glyph}}",
    nextGlyph: "Lanjut ke huruf {{glyph}}",
    nextShape: "Lanjut ke bentuk {{name}}",
    retryGlyph: "Ulangi huruf {{glyph}}",
    retryShape: "Ulangi bentuk {{name}}",
    colorGlyph: "Warnai huruf {{glyph}}",
    doneTitle: "Hebat, {{name}}!",
    doneSub: "Kamu berhasil menulis {{glyph}}. Terus semangat!",
    chipStars: "{{count}} bintang",
    chipLines: "{{count}} garis selesai",
    masteryLabel: "{{current}} dari {{total}} dikuasai",
    linesCount: "{{count}} garis",
    pickerHint: "Sentuh huruf untuk mulai menulis",
    unitUpper: "{{count}} huruf",
    unitLower: "{{count}} huruf kecil",
    unitDigit: "{{count}} angka",
    unitShape: "{{count}} bentuk",
    recommendation: "Rekomendasi untuk {{name}}",
    shape: {
      circle: "Lingkaran",
      oval: "Oval",
      square: "Persegi",
      rectangle: "Persegi panjang",
      triangle: "Segitiga",
      star: "Bintang",
      heart: "Hati",
      line: "Garis",
    },
  },
  games: {
    title: "Permainan",
    matching: "Cocokkan",
    balloon: "Pecahkan Balon",
    coloring: "Mewarnai",
    pick: "Pilih permainan favoritmu",
    matchingSub: "Cocokkan huruf besar & kecil",
    balloonSub: "Pecahkan balon berisi huruf",
    coloringSub: "Warnai angka & bentuk",
    play: "Mulai bermain",
    footer: "Setiap permainan memberi bintang untuk koleksimu!",
    progressTitle: "Progres bermain",
    starsEarned: "{{count}} bintang",
    played: "{{count}} kali main",
    progressSub: "Setiap permainan selesai memberi 1 bintang.",
    nextReward: "Hadiah berikutnya",
    nextRewardSub: "Kumpulkan 3 bintang untuk membuka stiker baru.",
    modeCase: "Besar - Kecil",
    modeObject: "Huruf - Gambar",
    casePrompt: "Cari huruf kecilnya",
    objectPrompt: "Huruf apa ini?",
    balloonPrompt: "Pecahkan balon: {{letter}}",
    repeat: "Ulangi",
    correct: "Benar!",
    wrong: "Coba lagi ya",
    playAgain: "Main Lagi",
    score: "{{correct}} dari {{total}} benar",
    colorHint: "Pilih warna, lalu sentuh hurufnya",
    stickers: "Stiker",
    clear: "Hapus",
    finish: "Selesai",
    finished: "Kerja bagus!",
    paint: "Warnai",
    painted: "{{painted}} dari {{total}} bagian diwarnai",
  },
  preview: {
    title: "Pratinjau Konten",
    hint: "Periksa bentuk semua huruf, angka, dan bentuk.",
  },
  rewards: {
    title: "Koleksi Hadiah",
    pick: "Koleksi stiker, piala, dan karakter",
    summary: "{{unlocked}} dari {{total}} hadiah terbuka",
    footer: "Selesaikan aktivitas untuk membuka hadiah baru.",
    kind: {
      sticker: "Stiker",
      trophy: "Piala",
      character: "Karakter",
    },
    unlocked: "Kamu dapat hadiah baru!",
    yeay: "Yeay!",
    locked: "Terkunci",
    done: "Selesai",
    requirement: {
      itemsAttempted: "Coba {{count}} aktivitas",
      itemsMastered: "Kuasai {{count}} huruf atau angka",
      starsEarned: "Kumpulkan {{count}} bintang",
      totalAttempts: "Mainkan {{count}} kali",
      kindMastered: "Kuasai {{count}} di satu kategori",
    },
  },
  avatar: {
    title: "Karakterku",
    pick: "Kustomisasi temanmu",
    footer: "Buka bagian baru dengan mengumpulkan hadiah.",
    slot: {
      color: "Warna",
      ears: "Telinga",
      eyes: "Mata",
      accessory: "Aksesori",
    },
  },
  categories: {
    upper: "Huruf Besar",
    lower: "Huruf Kecil",
    digits: "Angka",
    shapes: "Bentuk",
  },
  mastery: {
    new: "Baru",
    learning: "Belajar",
    familiar: "Lancar",
    mastered: "Mahir",
  },
  parent: {
    title: "Area Orang Tua",
    subtitle: "Pantau perkembangan dan atur aplikasi",
    gateTitle: "Khusus Orang Tua",
    gate: {
      question: "Berapa hasil dari {{a}} + {{b}}?",
      placeholder: "Jawaban",
      submit: "Masuk",
      wrong: "Jawaban belum tepat",
      cancel: "Batal",
    },
    progressFor: "Perkembangan {{name}}",
    progressQuick: "{{mastered}} dikuasai • {{attempted}} dicoba • ⭐ {{stars}}",
    report: "Laporan Perkembangan",
    navReport: "Laporan",
    summary: "Ringkasan",
    statMastered: "Dikuasai",
    statAttempted: "Dicoba",
    statStars: "Bintang",
    statAttempts: "Total Percobaan",
    levels: "Tingkat Penguasaan",
    byCategory: "Per Kategori",
    needsPractice: "Perlu Latihan",
    noWeak: "Semua yang dicoba sudah dikuasai. Hebat!",
    practiceDetail: "Akurasi {{score}}% • {{attempts}} kali",
    tracingQuality: "Kualitas Menulis",
    noTracing: "Belum ada latihan menulis.",
    avgAccuracy: "Rata-rata akurasi",
    traces: "Jumlah latihan",
    neverPlayed: "Belum ada aktivitas.",
    lastPlayed: "Terakhir bermain: {{date}}",
    screenTime: "Batas Waktu",
    sessionLimit: "Batas sesi",
    breakReminder: "Pengingat istirahat",
    breakOff: "Nonaktif",
    minutes: "{{minutes}} menit",
    sessionRemaining: "Sisa waktu sesi ini: {{time}}",
    settings: "Pengaturan",
    language: "Bahasa",
    haptics: "Getaran",
    audio: "Suara",
    reduceMotion: "Kurangi gerakan",
    switchProfile: "Ganti Anak",
    preview: "Pratinjau Konten",
    manageChildren: "Kelola Anak",
    activeChild: "Aktif",
    switchTo: "Pilih",
    delete: "Hapus",
    deleteConfirm: "Yakin hapus?",
    deleteHint: "Menghapus anak juga menghapus kemajuan dan koleksinya.",
    lastChildHint: "Minimal harus ada satu anak.",
    childLanguage: "Bahasa untuk {{name}}",
    cancel: "Batal",
  },
  session: {
    loading: "Sebentar ya…",
    expiredTitle: "Waktunya istirahat",
    expiredHint:
      "Sesi belajar hari ini sudah selesai. Minta Bunda atau Ayah membuka lagi ya.",
    parentUnlock: "Orang Tua",
    breakReminder: "Sudah {{minutes}} menit belajar. Istirahat dulu yuk!",
    breakDone: "Sudah istirahat",
  },
  settings: {
    errors: {
      invalidLocale: "Bahasa tidak valid",
      invalidSessionLimit: "Batas sesi tidak valid",
      invalidBreakReminder: "Pengingat istirahat tidak valid",
    },
  },
  error: {
    storage: "Gagal menyimpan data. Coba lagi ya.",
    retry: "Coba Lagi",
    reset: "Atur Ulang Data",
    resetHint: "Menghapus semua profil dan kemajuan di perangkat ini.",
    crash: "Ayah, ada yang-error. Coba lagi ya.",
    crashRetry: "Coba Lagi",
  },
  landing: {
    nav: {
      skip: "Lewati ke konten",
    },
    hero: {
      tagline: "Belajar aksara sambil bermain",
      subtitle: "Menulis huruf, angka, dan bentuk untuk anak usia 3+. Tanpa internet pun tetap jalan.",
      mascotGreeting: "Halo!",
    },
    languages: {
      id: "Indonesia",
      en: "English",
      ar: "العربية",
    },
    onboarding: {
      age: "Usia 3+",
      offline: "100% offline",
      languages: "3 bahasa",
      safe: "Aman anak",
      languageLabel: "PILIH BAHASA · LANGUAGE",
      cta: "Mulai belajar",
      parentLink: "Untuk orang tua · kelola profil & waktu layar",
    },
    install: {
      instructions: "Cara Memasang",
      ios: "Ketuk tombol Bagikan, lalu pilih \"Tambah ke Layar Utama\".",
      android: "Ketuk menu, lalu pilih \"Tambah ke layar utama\".",
      desktop: "Klik ikon pasang di address bar, atau gunakan menu browser.",
      openApp: "Buka Aplikasi",
    },
  },
} as const;
